module.exports = "<ui-form-element\n    [title]=\"title\"\n    [description]=\"description\"\n    [highlightPhrase]=\"highlightPhrase\">\n\n     <ui-checkbox [id]=\"id\"\n                  [name]=\"name\"\n                  [disabled]=\"disabled\"\n                  [(ngModel)]=\"innerValue\">\n     </ui-checkbox>\n\n</ui-form-element>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-checkbox/fe-checkbox.html
// module id = 1094
// module chunks = 3